// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__14vgU","header":"MessagesList_header__2Hqki","chat":"MessagesList_chat__1IZSy"};